import { render, staticRenderFns } from "./StackBarChart.vue?vue&type=template&id=27ac0022&scoped=true&"
import script from "./StackBarChart.vue?vue&type=script&lang=js&"
export * from "./StackBarChart.vue?vue&type=script&lang=js&"
import style0 from "./StackBarChart.vue?vue&type=style&index=0&id=27ac0022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ac0022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
